import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { LogoutOutlined } from '@ant-design/icons';
import { Divider } from 'antd';

import { UserDisplay } from 'entities/user/ui/UserDisplay/UserDisplay';
import { ButtonStyled, UserMenuStyled } from './UserMenu.styles';

interface Props {
	name: string;
	login: string;
}

export const UserMenu: FC<Props> = ({ name, login }) => {
	const { t } = useTranslation();

	return (
		<UserMenuStyled>
			<UserDisplay name={name} login={login} />
			<Divider style={{ margin: `4px 0` }} />
			<ButtonStyled
				type='link'
				danger
				icon={<LogoutOutlined />}
				href={`/privateapi/auth/logout?returnUrl=${window.location.origin}`}
			>
				{t(`Marketplace_Log_Out`)}
			</ButtonStyled>
		</UserMenuStyled>
	);
};
